import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';
gsap.registerPlugin(
  ScrollTrigger,
  MotionPathPlugin,
);
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.MotionPathPlugin = MotionPathPlugin;

document.addEventListener('DOMContentLoaded', () => {
  if (window.location.pathname !== '/') {
    return;
  }

  // 取得 svg
  const circlePath = MotionPathPlugin.convertToPath("#earth-orbit", false)[0];
  circlePath.id = "circlePath";
  document.querySelector("svg").prepend(circlePath);

  // 取得所有 item
  const allItems = gsap.utils.toArray(".location-item");
  const allButtons = gsap.utils.toArray(".location-button");

  // 響應式函數：根據螢幕寬度決定顯示的項目數量
  function getMaxItems() {
    if (window.innerWidth <= 1200) {
      return 10;
    // } else if (window.innerWidth <= 1200) {
    //   return 8;
    } else {
      return allItems.length;
    }
  }

  // 初始化變數
  let items, buttons, numItems, itemStep, wrapProgress, snap, itemsArray, buttonsArray, tracker, tl, earthImgBgRotation = 0;

  function initAnimation() {
    // 根據螢幕寬度取得要顯示的項目
    const maxItems = getMaxItems();
    items = allItems.slice(0, maxItems);
    buttons = allButtons.slice(0, maxItems);

    // 隱藏多餘的項目
    allItems.forEach((item, index) => {
      if (index >= maxItems) {
        item.style.display = 'none';
      } else {
        item.style.display = '';
        // 重設 CSS 動畫，讓動畫重新播放
        item.style.animation = 'none';
        item.offsetHeight; // 強制重排
        item.style.animation = null;
      }
    });

    numItems = items.length;  // 取得項目總數量
    itemStep = 1 / numItems;    // 計算每個項目在圓周上的步長
    wrapProgress = gsap.utils.wrap(0, 1); // 包裝進度，將進度限制在0到1之間
    snap = gsap.utils.snap(itemStep); // 建立對齊函數，讓動畫停在精確的項目位置

    //項目陣列處理，直接使用 items 陣列
    itemsArray = items;

    //按鈕陣列處理，直接使用 buttons 陣列
    buttonsArray = buttons;

    let wrapTracker = gsap.utils.wrap(0, numItems);

    //add active class to first item and button
    itemsArray[0].classList.add('active');
    buttonsArray[0].classList.add('active');

    gsap.set(items, {
      motionPath: {
        path: circlePath,     // 使用之前建立的圓形路徑
        align: circlePath,    // 讓項目對齊到路徑上
        alignOrigin: [0.5, 0.5],  // 設定對齊原點為項目中心
        end: i => (i / items.length) + 0.75, // 第一個項目在12點鐘位置（0.75）
        autoRotate: true      // 將 autoRotate 移到 motionPath 配置中
      },
      scale: 0.9 // 將所有項目縮放
    });

    tracker = {
      item: 0 // 初始項目為0
    }

    tl = gsap.timeline({ paused: true, reversed: true });

    tl.to('.earth-circle', {
      rotation: 360,
      transformOrigin: 'center',
      duration: 1,
      ease: 'none'
    });

    tl.to(tracker, {
      item: numItems,
      duration: 1,
      ease: 'none',
      modifiers: {
        item(value) {
          return wrapTracker(numItems - Math.round(value))
        }
      },
      onUpdate: updateActiveState
    }, 0);

    // 清除舊的事件監聽器
    items.forEach((el, i) => {
      el.removeEventListener("click", handleItemClick);
      el.addEventListener("click", handleItemClick);
    });

    // 清除舊的按鈕事件監聽器
    const prevBtn = document.getElementById('earth-prev');
    const nextBtn = document.getElementById('earth-next');
    if (nextBtn) {
      nextBtn.removeEventListener("click", handleNextClick);
      nextBtn.addEventListener("click", handleNextClick);
    }
    if (prevBtn) {
      prevBtn.removeEventListener("click", handlePrevClick);
      prevBtn.addEventListener("click", handlePrevClick);
    }
  }

    // 更新 active 狀態的函數
  function updateActiveState() {
    // 移除所有 active 類別
    itemsArray.forEach(item => item.classList.remove('active'));
    buttonsArray.forEach(button => button.classList.remove('active'));

    // 根據當前 tracker.item 添加 active 類別
    const activeIndex = tracker.item;
    if (itemsArray[activeIndex]) {
      itemsArray[activeIndex].classList.add('active');
    }
    if (buttonsArray[activeIndex]) {
      buttonsArray[activeIndex].classList.add('active');
    }
  }

  // 事件處理函數
  function handleItemClick() {
    // 計算被點擊項目需要旋轉到 12 點鐘位置的角度
    let targetProgress = 0.75; // 12 點鐘位置
    let currentProgress = tl.progress();

    // 計算需要移動的距離
    let moveAmount = targetProgress - currentProgress;

    // 如果移動距離超過 0.5，選擇較短的路徑
    if (Math.abs(moveAmount) > 0.5) {
      moveAmount = moveAmount > 0 ? moveAmount - 1 : moveAmount + 1;
    }

    // 執行旋轉
    moveWheel(moveAmount);
  }

  function handleNextClick() {
    moveWheel(-itemStep);
    // 逆時針旋轉 earth-img-bg 5度
    earthImgBgRotation += 5;
    rotateEarthImgBg();
  }

  function handlePrevClick() {
    moveWheel(itemStep);
    // 順時針旋轉 earth-img-bg 5度
    earthImgBgRotation -= 5;
    rotateEarthImgBg();
  }

  function moveWheel(amount) {
    gsap.to(tl, {
      progress: snap(tl.progress() + amount),
      modifiers: {
        progress: wrapProgress
      }
    });
  }

  function rotateEarthImgBg() {
    const earthImgBg = document.querySelector('.earth-img-bg');
    if (earthImgBg) {
      gsap.to(earthImgBg, {
        rotation: earthImgBgRotation,
        duration: 0.5,
        ease: 'power2.out'
      });
    }
  }
  initAnimation();
});

// 基礎動畫 - 全站執行
document.addEventListener('DOMContentLoaded', () => {
  if ($('.show-opacity').length) {
    gsap.set(".show-opacity", { opacity: 0 });
    ScrollTrigger.batch(".show-opacity", {
      onEnter: function onEnter(batch) {
        gsap.to(batch, { opacity: 1, stagger: 0.3 });
      },
    });
  }
  if ($('.show-zoom-in').length) {
    gsap.set(".show-zoom-in", { opacity: 0, scale: 0.8 });
    ScrollTrigger.batch(".show-zoom-in", {
      onEnter: function onEnter(batch) {
        gsap.to(batch, { ease: 'power1.inOut', opacity: 1, scale: 1, stagger: 0.3 });
      },
    });
  }
  if ($('.show-zoom-in-fast').length) {
    gsap.set(".show-zoom-in-fast", { opacity: 0, scale: 0.6 });
    ScrollTrigger.batch(".show-zoom-in-fast", {
      onEnter: function onEnter(batch) {
        gsap.to(batch, { ease: 'power1.inOut', opacity: 1, scale: 1, stagger: 0.1 });
      },
    });
  }
  if ($('.show-in-top').length) {
    gsap.set(".show-in-top", { opacity: 0, y: -30 });
    ScrollTrigger.batch(".show-in-top", {
      onEnter: function onEnter(batch) {
        gsap.to(batch, { ease: 'back.out(1.5)', opacity: 1, y: 0, stagger: 0.6 });
      },
    });
  }
  if ($('.show-in-bottom').length) {
    gsap.set(".show-in-bottom", { opacity: 0, y: 30 });
    ScrollTrigger.batch(".show-in-bottom", {
      onEnter: function onEnter(batch) {
        gsap.to(batch, { ease: 'back.out(1.5)', opacity: 1, y: 0, stagger: 0.6 });
      },
    });
  }
  if ($('.show-to-top').length) {
    gsap.set(".show-to-top", { y: 50, opacity: 0 });
    ScrollTrigger.batch(".show-to-top", {
      onEnter: function onEnter(batch) {
        gsap.to(batch, { opacity: 1, y: 0, stagger: 0.1 });
      },
    });
  }

  if ($('.show-in-left').length) {
    gsap.set(".show-in-left", { x: -10, opacity: 0 });
    ScrollTrigger.batch(".show-in-left", {
      onEnter: function onEnter(batch) {
        gsap.to(batch, { opacity: 1, x: 0, stagger: 0.1 });
      },
    });
  }
  if ($('.show-in-right').length) {
    gsap.set(".show-in-right", { x: 10, opacity: 0 });
    ScrollTrigger.batch(".show-in-right", {
      onEnter: function onEnter(batch) {
        gsap.to(batch, { opacity: 1, x: 0, stagger: 0.1 });
      },
    });
  }
  if ($('.show-in').length) {
    gsap.set(".show-in", {});
    ScrollTrigger.batch(".show-in", {
      onEnter: function onEnter(batch) {
        batch.forEach(el => el.classList.add("animate"));
        gsap.to(batch, { stagger: 0.3 });
      },
    });
  }

  // Slide tabs sticky functionality
  // if ($('.slide-tabs').length) {
  //   const tabs = document.querySelector('.slide-tabs');
  //   ScrollTrigger.create({
  //     scrollTrigger: tabs,
  //     start: 'top top',
  //     endTrigger: "footer",
  //     toggleClass: { targets: tabs, className: "fixed" }
  //   });
  // }
});
